import { useState } from "react";
import { useEffect } from "react";
import "./home.scss";
import "./x.scss";
import "@fortawesome/fontawesome-free/scss/fontawesome.scss";
import "@fortawesome/fontawesome-free/scss/solid.scss";

import Header from "../../components/molecules/header/Header";
import Footer from "../../components/molecules/footer/Footer";
import TramLab from "../../components/molecules/categorias/TramLab";
import TramSelPro from "../../components/molecules/categorias/TramSelPro";
import MisDatos from "../../components/molecules/categorias/MisDatos";
import { visualizarSeccionConcursos } from "../../components/services/ConcursosService";
import { useLocalStorage } from "../../hooks/useLocalStorage";
import ModalAvisoHome from "../../components/molecules/modals/modalAvisoHome/ModalAvisoHome";


function Home() {
  //oculto la seccion entera hasta si
  const [user] = useLocalStorage("user", "")
  const [concursosVisible, setConcursosVisible] = useState(false);
  const [showModalHome, setShowModalHome] = useState(false)
  const [hayModal] = useState(localStorage.getItem("showModalHome"))

  const handleClose = (e) => {
    setShowModalHome(false);
  };

  useEffect(() => {
    if (user) {
      visualizarSeccionConcursos().then((data) => {
        setConcursosVisible(data);
      })
      if (hayModal) {
        setShowModalHome({
          mensaje: true,
          // content:
          //   "¿Deseas cancelar el formulario?",
          tipo: "tituloModal",
          aviso: true,
          destinoAviso: null,
          destinoCerrar: null,
        })
      }

    }

  }, [user,hayModal]);

  return (
    <>
      <Header></Header>
      <div role="main" data-landmark-index="4">
        {/* <div className="alert alert-warning m-5 " role="alert">
          <p>⚠️ Va a tener acceso a documentación confidencial que contiene datos de carácter personal e información privada de su exclusivo interés. Se le recomienda que no facilite a terceros estos documentos o el acceso a los mismos. Es su responsabilidad.</p>
        </div> */}
        <MisDatos></MisDatos> {/*Mis consultas*/}
        <TramLab></TramLab> {/*Mis trámites*/}
        {concursosVisible ? (<TramSelPro></TramSelPro>) : null} {/*Mis convocatorias*/}
      </div>
      {/* <ActosAdmin></ActosAdmin> Actos administrativos */}
      <Footer></Footer>
      {showModalHome.mensaje ? (<>
        <ModalAvisoHome
          show={showModalHome.mensaje}
          aviso={showModalHome.aviso}
          handleClose={handleClose}
          alerta="Este portal le da acceso a datos personales con información confidencial. El acceso, uso y custodia de esta información queda estrictamente bajo su responsabilidad, debiendo garantizar en todo momento su correcta protección, confidencialidad y almacenamiento seguro."
          tipo="tituloBorrador rojo"
        ></ModalAvisoHome>
      </>) : null}
    </>
  );
}

export default Home;
